<template>
    <div>

        <accuracy-list-link :listLayout="listLayout" :listData="List"
                            :paginationData="filterSet.page"></accuracy-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>

import VuxAlert from "@/mixins/alertMixins";
import localStorage from "@/mixins/localStorage";
import elasticList from "@/mixins/elastic/elasticList";
import imageOption from "@/mixins/imageOption";
import accuracyUtil from "@/components/accuracy/accuracyUtil";
import EventBus from "@/mixins/event-bus";
import filterMixins from "@/mixins/filterMixins";
import listMixins from "@/mixins/listMixins";
import util from "@/mixins/util";
import AccuracyListLink from "@/components/accuracy/link/AccuracyListLink";
import PaginationLink from "@/components/accuracy/link/PaginationLink";


const {filterConfig} = accuracyUtil;
export default {
    name: "AccuracyListComponent",
    components: {PaginationLink, AccuracyListLink,},
    props: {
        listType: {
            default: () => '',
        },

    },
    provide() {
        return {
            setPage: this.setPage,
        }
    },

    mixins: [imageOption, filterMixins, listMixins, accuracyUtil],
    data() {
        return {
            getFunc: '',
            listLayout: '',
            paginationLayout: '',
            listApiParamSet: {},
            insertFunc: '',

            pageRow: '',
            paginationType: '',

            listCount: 0,
        }
    },
    created() {
        this.initConfig();
        this.setFilterConfig(filterConfig);
        this.setParserType('url', this.$route.fullPath);
    },
    mounted() {
        this.getList(true);
        EventBus.$on('insertData', this.insertData);
    },
    beforeDestroy() {
        EventBus.$off('insertData');
    },
    destroyed() {
    },
    computed: {},
    methods: {
        initConfig() {
            let config = this.returnAccuracyConfig(this.listType);
            this.listLayout = config.listLayout;
            this.paginationLayout = config.paginationLayout;
            this.listApiParamSet = config.listApiParamSet;
            this.insertFunc = config.insertFunc;
            this.getFunc = config.getFunc;
            this.isCategory = config.isCategory;

            this.categoryApiParamSet = config.categoryApiParamSet;


            this.pageRow = config.pageRow;
            this.paginationType = config.paginationType;

            if (config.pageRow && config.pageRow !== this.filterSet.page.size) {
                this.pageRow = config.pageRow;
                this.filterSet.page.size = config.pageRow;
                this.pageClass.setterPage('size', this.pageRow);
            }

            let defaultParams = Object.assign({}, this.listApiParamSet);

            let listOptions = {
                url: this.$api.$predict[this.getFunc],
                defaultParams: defaultParams,
            }
            this.initList('api', listOptions);
        },


        async insertData() {
            EventBus.$emit('changeLoading', true)
            let params = {}
            try {

                this.$api.$predict[this.insertFunc](params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading', false)
                    if (res.Info.Type == 1) {
                        this.getList();
                    } else {
                        this.errorAlert('데이터 등록을 실패하였습니다.');
                    }
                })
            } catch (e) {
                EventBus.$emit('changeLoading', false)
                console.log(e);
            }
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>